import { EnglishStrategy as e } from "./english-strategy.js";
import { NepaliStrategy as t } from "./nepali-strategy.js";
// src/design/forms/datepicker/core/libs/strategy/strategy-provider.ts
var n = (n) => n ? t : e;
export { n as getStrategy };

//# sourceMappingURL=strategy-provider.js.map